import React from 'react';
import { Link } from 'react-router-dom';
import { formatDateTime, timeAgo } from '../utils/dateHelpers';
import './NewsCard.css';

const LANG_LABELS = {
  telugu: { label: 'తెలుగు', cls: 'badge-telugu' },
  hindi: { label: 'हिन्दी', cls: 'badge-hindi' },
};

export default function NewsCard({ article, size = 'normal' }) {
  const { id, title, displayTitle, category, author, thumbnailURL, content, createdAt, language, languages } = article;

  // Use displayTitle (localized) if available, else fall back to default title
  const cardTitle = displayTitle || title || '';
  const excerpt = content ? content.replace(/<[^>]+>/g, '').slice(0, 120) + '...' : '';

  // Determine language badges to show
  // New articles have 'languages' array; old articles have 'language' string
  const langList = Array.isArray(languages)
    ? languages
    : (language ? language.split(',').map(l => l.trim()) : ['english']);
  const langBadges = langList.filter(l => l && l !== 'english' && LANG_LABELS[l]);

  return (
    <article className={`news-card card size-${size}`}>
      <Link to={`/article/${id}`} className="card-image-link">
        <div className="card-image">
          {thumbnailURL
            ? <img src={thumbnailURL} alt={cardTitle} loading="lazy" />
            : <div className="card-image-placeholder">📰</div>
          }
          <span className="badge card-cat-badge">{category}</span>
          {langBadges.map(l => (
            <span key={l} className={`badge card-lang-badge ${LANG_LABELS[l].cls}`}>{LANG_LABELS[l].label}</span>
          ))}
        </div>
      </Link>
      <div className="card-body">
        <Link to={`/article/${id}`} className="card-title-link">
          <h3 className="card-title">{cardTitle}</h3>
        </Link>
        {size !== 'small' && <p className="card-excerpt">{excerpt}</p>}
        <div className="card-meta">
          <span className="card-author">✍️ {author}</span>
          <span className="card-time" title={formatDateTime(createdAt)}>{timeAgo(createdAt)}</span>
        </div>
      </div>
    </article>
  );
}